import { sectionLabels } from "../section-labels";
import { colorFields } from "./_shared";
/**
 * Instagram feed — a manual, seller-curated image grid styled like an
 * Instagram gallery (no live API). Each `instagram-tile` block is an image
 * with an optional outbound link; an optional @handle header links to the
 * seller's profile. Five layout variants.
 */
export const instagramSchema = {
    type: "instagram",
    name: sectionLabels["instagram"],
    description: {
        ar: "شبكة صور بأسلوب إنستغرام مع رابط حسابك.",
        en: "An Instagram-style image grid linking to your profile.",
    },
    maxPerTemplate: 2,
    settings: [
        {
            id: "variant",
            type: "select",
            ui: "thumbnail",
            label: { ar: "نوع العرض", en: "Layout" },
            helpText: { ar: "طريقة عرض الصور.", en: "How the tiles are laid out." },
            options: [
                { value: "ig-grid", label: { ar: "شبكة", en: "Grid" } },
                { value: "ig-row", label: { ar: "صف", en: "Row" } },
                { value: "ig-masonry", label: { ar: "متداخل", en: "Masonry" } },
                { value: "ig-carousel", label: { ar: "شرائح", en: "Carousel" } },
                { value: "ig-highlight", label: { ar: "مميز", en: "Highlight" } },
            ],
            default: "ig-grid",
        },
        // NB: no `eyebrowField()` here. An eyebrow ("a small label above the title")
        // and a `@handle` are the same line to a seller, so the section shipped two
        // controls for one idea. The handle is the one that survives: it is a single
        // string (an Instagram account is not per-locale — an i18n eyebrow would let
        // the AR and EN storefronts link to DIFFERENT profiles) and it drives both
        // the `@handle` line and the Follow link.
        {
            id: "title",
            type: "text",
            i18n: true,
            label: { ar: "العنوان (اختياري)", en: "Title (optional)" },
            validate: { max: 60 },
        },
        {
            id: "handle",
            type: "text",
            label: { ar: "حساب إنستغرام", en: "Instagram handle" },
            helpText: {
                ar: 'من غير @. بيظهر تحت العنوان مع زر "متابعة" يفتح حسابك.',
                en: 'Without the @. Shows your @handle under the title, with a "Follow" link to your profile.',
            },
            validate: { max: 30 },
        },
        {
            id: "followLabel",
            type: "text",
            i18n: true,
            label: { ar: "نص زر المتابعة", en: "Follow button label" },
            validate: { max: 24 },
            default: { ar: "تابعنا", en: "Follow" },
            // E3: the Follow button only renders once a handle is set
            // (`InstagramSection.tsx` gates the whole link on it), so its label is a
            // dead control until then.
            showIf: { handle: "$set" },
        },
        {
            id: "headingLevel",
            type: "headingLevel",
            label: { ar: "مستوى العنوان", en: "Heading level" },
            default: 2,
        },
        ...colorFields(),
    ],
    blocks: [
        {
            type: "instagram-tile",
            name: { ar: "صورة", en: "Post" },
            description: {
                ar: "صورة مع رابط اختياري.",
                en: "An image with an optional link.",
            },
            maxPerSection: 12,
            settings: [
                {
                    id: "image",
                    type: "image",
                    focalPoint: true,
                    label: { ar: "الصورة", en: "Image" },
                },
                {
                    id: "link",
                    type: "url",
                    label: { ar: "الرابط (اختياري)", en: "Link (optional)" },
                },
            ],
        },
    ],
};
//# sourceMappingURL=instagram.js.map